import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Project } from 'src/app/shared/models/project';
import { Constants } from 'src/app/shared/utils/constants';
import { Subscription } from 'rxjs';
import { RunApiService } from 'src/app/shared/services/run.api.service';
import { InputsResultSummaryPWC, ResultSummaryPWC } from './eea-output-project-pwc.interface.model';
import { ColDef } from 'ag-grid-community';
import { EeaOutputProjectPwcLogicService } from './eea-output-project-pwc.logic.service';
import { isPwcV2Project } from 'src/app/shared/utils/pwc-version.utils';

@Component({
  selector: 'app-eea-output-project-pwc',
  templateUrl: './eea-output-project-pwc.component.html'
})
export class EeaOutputProjectPwcComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isProjectOwnershipValid: boolean = false;
  @Input() selectedModel?: string;
  @Input() selectedProject?: Project;
  @Input() selectedProjectRunsSaved?: boolean;
  @Input() selectedProjectStatus?: number;

  public activeIndex = -1;
  public columnDefs: ColDef[] = [];
  public disabledInputs: boolean = true;
  public disabledInputsSubscription: Subscription | undefined;
  public disabledSummary = true;
  public inputsRowData: InputsResultSummaryPWC[] = [];
  public isLoading: boolean = false;
  public isPwc2: boolean = false;
  public rawData: ResultSummaryPWC[] = [];

  private logicService = inject(EeaOutputProjectPwcLogicService);
  private runApiService = inject(RunApiService);

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes[Constants.SELECTED_PROJECT_STATUS]){
      this.disabledSummary = !(this.selectedProjectStatus == Constants.PROJECT_STATUS_ID.SUCCESSFUL);

      if(this.selectedProjectStatus == Constants.PROJECT_STATUS_ID.SUCCESSFUL)
        await this.getSummaryResultPwc();
    }


    if (changes[Constants.SELECTED_PROJECT_RUNS_SAVED])
      this.disabledInputs = !this.selectedProjectRunsSaved;
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    const projectPk = this.selectedProject?.projectPk;
    if( projectPk === undefined ) return;
    this.isPwc2 = this.selectedProject ? isPwcV2Project(this.selectedProject) : false;
    this.inputsRowData = await this.logicService.getResultSummaryPwcInputs(projectPk);
    this.updateDisabledStates();
    this.isLoading = false;
  }

  private updateDisabledStates(): void {
    this.disabledSummary = !(this.selectedProject?.status == Constants.PROJECT_STATUS_ID.SUCCESSFUL);
    if (this.selectedProject) {
      try {
        this.disabledInputsSubscription = this.runApiService.runsHaveBeenSavedPwc(this.selectedProject.projectPk).subscribe((value: boolean) => {
          this.disabledInputs = !value;
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  private async getSummaryResultPwc(): Promise<void>{
    this.isLoading = true;
    this.rawData = await this.logicService.getSummaryResultPwc(this.selectedProject!.projectPk);
    this.isLoading = false;
  }

  public async onTabChange(): Promise<void>{
    this.getSummaryResultPwc();
  }

  ngOnDestroy(): void {
    if (this.disabledInputsSubscription) {
      this.disabledInputsSubscription.unsubscribe();
    }
  }
}
